const endpoints = {
  menu: `api/voci-menu`,
  footer: `api/footer`,
  cookies: `api/cookie-configuration`,
  rules: `api/menu-regolamenti`,
  rule: `api/regolamento`,
  banner: "api/banner",
  privateArea: {
    login: `api/xmlgateway/user/login`,
    logout: `api/xmlgateway/user/logout`,
    balance: "api/xmlgateway/user/get-balance",
    menu_messages: "api/xmlgateway/user/get-menu-message",
    unread_messages: "api/xmlgateway/user/get-unread-messages-count",
    user_messages: "api/xmlgateway/user/get-messages",
    user_message: "api/xmlgateway/user/get-message",
    set_message: "api/xmlgateway/user/set-message",
    transactions: "api/xmlgateway/user/get-transactions",
    transactions_filters: "api/xmlgateway/user/get-transactions-filters",
    ticket: "api/xmlgateway/user/get-ticket",
    user_deposits: "api/xmlgateway/user/get-deposits",
    user_withdrawals: "api/xmlgateway/user/get-withdrawals",
    user_bonus: "api/xmlgateway/user/get-bonus",
    open_bets: "api/xmlgateway/user/get-open-bets",
    games_limits: "api/xmlgateway/user/get-games-limits",
    self_exclusion_periods: "api/xmlgateway/user/exclusion-period",
    get_exclusion_reasons: "api/xmlgateway/user/oasis-exclusion-reasons",
    select_exclusion_reason: "api/xmlgateway/user/oasis-exclusion",
    select_ban_period: "api/xmlgateway/user/perform-exclusion",
    changeData: "api/xmlgateway/user/change-data",
    changePassword: "api/xmlgateway/user/change-password",
    changePrivacy: "api/xmlgateway/user/change-privacy",
    trackChangeArea: "/api/xmlgateway/user/track_change_area",
    changeGamesLimits: "api/xmlgateway/user/set-games-limits",
    setGlobalLimit: "/api/xmlgateway/user/set-global-deposit-limits",
    cashout_availability: "api/xmlgateway/user/get-cashout-availability",
    get_cashout_service: "api/xmlgateway/user/get-cashout-service",
    cashout_request: "api/xmlgateway/user/cashout-request",
    check_session: "/api/xmlgateway/check/token",
    lugasRealityCheck: "api/xmlgateway/user/lugas_reality_check",
    show_jumio_documents: "/api/xmlgateway/user/show-jumio-documents",
    load_jumio_documents: "api/xmlgateway/user/load-jumio-documents",
    set_winning_threshold: "/api/xmlgateway/user/set-winning-threshold",
    get_winning_threshold: "/api/xmlgateway/user/get-winning-threshold",
  },
  registration: {
    registrationQuestions: "api/xmlgateway/user/registration-secret-questions",
    registrationDocuments: "api/xmlgateway/user/registration-documents",
    registrationStates: "api/xmlgateway/user/registration-states",
    registrationNations: "api/xmlgateway/user/registration-nations",
    checkUsername: "api/xmlgateway/check/username",
    checkEmail: "api/xmlgateway/check/email",
    registrationSubmit: "api/xmlgateway/user/registration",
    documentUpload: "api/xmlgateway/user/upload-documents",
    cardAssociation: "api/xmlgateway/user/unique-registration"
  },
  recoverPassword: {
    password_request_reset: "api/xmlgateway/user/request-password-reset",
    password_check_reset: "api/xmlgateway/user/check-password-reset",
    password_reset: "api/xmlgateway/user/password-reset",
  },
  promo: {
    menu: "api/promo-menu",
    allPromos: `api/all-promo`,
    archived: "api/archived-promo",
    details: "api/details-promo",
    getByPath: "api/promo-by-path",
  },
  pages: {
    allPages: "api/all-pages",
    pageById: "api/page-by-id",
    pageByPath: "api/page-by-path",
  },
  seo: {
    description: "api/get_seo_description",
  },
  seamless: {
    login: "api/xmlgateway/user/seamless/${token}/${carta}/${client}/${call}",
  },
};

export default endpoints;
